import { PrinterPosSyncOutlineIcon } from './PrinterPosSyncOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 0F86AA93-8706-4290-B11A-FDC58392F543
 * name printer-pos-sync-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-sync-outline.svg
 * tags
 * - Printer 
 */
export const PrinterReceiptSyncOutlineIcon = PrinterPosSyncOutlineIcon;
export default PrinterReceiptSyncOutlineIcon